// extracted by mini-css-extract-plugin
module.exports = {"ResetPassword_requestConfirmation":"ResetPassword_ResetPassword_requestConfirmation__GKctf"};